<app-header-auth></app-header-auth>

<div class="m-auto container ">
    
 
    <div class="card login-form border-0 m-auto">

      <div class="card-header border-0 bg-none  text-center">
        <h4> {{ 'SIGNUP' | translate }} </h4>
      </div>

      <div class="card-body p-0">

        <form class="form"  [formGroup]="validateForm" (ngSubmit)="submitForm()">
            
            <div class="form-floating mb-3 has-validation">
                <input
                    type="text"
                    id="name"
                    class="form-control"
                    [ngClass]="{'is-invalid': error?.name}"
                    formControlName="name"
                    placeholder="{{ 'NAME' | translate }}">
                <label for="name">{{ 'NAME' | translate }}</label>
                <div class="invalid-feedback">
                    <!-- {{ error?.name }} -->
                    {{ 'VALIDATION.NAME_REQUIRED' | translate }}
                </div>
            </div>
    
            <div class="form-floating mb-3">
                <input
                    type="text"
                    [ngClass]="{'is-invalid': error?.lastname}"
                    id="lastname"
                    class="form-control"
                    formControlName="lastname"
                    placeholder="{{ 'LASTNAME' | translate }}">
                <label for="lastname">{{ 'LASTNAME' | translate }}</label>
                <div class="invalid-feedback">
                    <!-- {{ error?.lastname }} -->
                    {{ 'VALIDATION.LASTNAME_REQUIRED' | translate }}
                </div>
            </div>
    
            <div class="form-floating mb-3">
                <input
                    type="email"
                    [ngClass]="{'is-invalid': error?.email}"
                    id="email"
                    class="form-control"
                    formControlName="email"
                    placeholder="{{ 'EMAIL' | translate }}"
                    autocomplete="new-email">
                <label for="email">{{ 'EMAIL' | translate }}</label>
                <div class="invalid-feedback">
                    <span *ngIf="error?.email?.includes('validation.EMAIL_REQUIRED')">{{ 'VALIDATION.EMAIL_REQUIRED' | translate }}</span>
                    <span *ngIf="error?.email?.includes('validation.EMAIL_UNIQUE')">{{ 'VALIDATION.EMAIL_UNIQUE' | translate }}</span>
                    <span *ngIf="error?.email?.includes('validation.EMAIL_INVALID')">{{ 'VALIDATION.EMAIL_INVALID' | translate }}</span>
                </div>
            </div>
    
            <div class="form-floating mb-3">
                <input
                    type="password"
                    id="password"
                    formControlName="password"
                    class="form-control"
                    [ngClass]="{'is-invalid': passwordErrors?.length}"
                    placeholder="{{ 'PASSWORD' | translate }}"
                    autocomplete="new-password">
                <label for="password">{{ 'PASSWORD' | translate }}</label>

                <div class="password-strength mt-2" *ngIf="isTyping">
                    <div class="progress">
                      <div class="progress-bar"
                           [ngClass]="{'bg-danger': passwordStrength <= 40, 'bg-warning': passwordStrength > 40 && passwordStrength < 80, 'bg-success': passwordStrength >= 80}"
                           [style.width.%]="passwordStrength"></div>
                    </div>
                    <small *ngIf="passwordStrength <= 40" class="text-danger">{{ 'VALIDATION.PASSWORD_STRENGTH_WEAK' | translate }}</small>
                    <small *ngIf="passwordStrength > 40 && passwordStrength < 80" class="text-warning">{{ 'VALIDATION.PASSWORD_STRENGTH_MEDIUM' | translate }}</small>
                    <small *ngIf="passwordStrength >= 80" class="text-success">{{ 'VALIDATION.PASSWORD_STRENGTH_STRONG' | translate }}</small>
                </div>
              
                <div class="invalid-feedback" *ngIf="passwordErrors?.length">
                    <div class="w-100" *ngIf="passwordErrors?.includes('validation.PASSWORD_REQUIRED')">{{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}</div>
                    <div class="w-100" *ngIf="passwordErrors?.includes('validation.PASSWORD_MIN')">{{ 'VALIDATION.PASSWORD_MIN' | translate }}</div>
                    <div class="w-100" *ngIf="passwordErrors?.includes('validation.PASSWORD_LOWERCASE')">{{ 'VALIDATION.PASSWORD_LOWERCASE' | translate }}</div>
                    <!-- <div class="w-100" *ngIf="passwordErrors?.includes('validation.PASSWORD_UPPERCASE')">{{ 'VALIDATION.PASSWORD_UPPERCASE' | translate }}</div> -->
                    <div class="w-100" *ngIf="passwordErrors?.includes('validation.PASSWORD_NUMBER')">{{ 'VALIDATION.PASSWORD_NUMBER' | translate }}</div>
                </div>
            </div>
    
            <div class="form-check form-switch mb-3">
                <input 
                    class="form-check-input"  
                    formControlName="check" 
                    [ngClass]="{'text-danger': error?.check}"  type="checkbox" id="rusel">
                <label class="form-check-label rusel" for="rusel"></label> 
                <a href="/rules" target="_blank" class="form-check-label rusel" > {{'I_AGRER_TO_THE_TEARMS_AND_CONDITIONS' | translate}}</a>
            </div>
            
            <div class="form-floating mb-3">
                <button
                        class="btn w-100  btn-primary btn-lg rounded-3" [disabled]="validateForm.invalid || loading || !validateForm.controls['check'].value">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" ></span>
                    {{ 'SIGNUP' | translate }}
                </button>
            </div>
    
            <a routerLink="/reset/password" class="text-muted">{{ 'RESETPASS' | translate }}</a>

            <div class="d-flex align-items-center justify-content-center mt-2">
                <p class="mb-0 me-2">{{ 'YES_ACCAUNT' | translate}} ?</p>
                <a type="button" routerLink="/signin"  class="btn btn-outline-danger">{{ 'SIGNIN' | translate }}</a>
            </div>
            
        </form>


      </div>

    </div>
      
</div>


  

